// 表示整形。page/2511 の実装と同じ結果になるようにしてある。

/**
 * innerHTML に差し込む値のエスケープ。
 * 原文(page/2511)は & < > " の4文字だったが、属性値を ' で囲む書き方が紛れても壊れないよう
 * シングルクォートも落とす。
 */
export function esc(s: unknown): string {
  const map: Record<string, string> = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  }
  return String(s == null ? '' : s).replace(/[&<>"']/g, (c) => map[c]!)
}

/**
 * href / window.open に渡す前のURL検証。
 *
 * 追跡URLは API が組み立てた値だが、
 * レスポンスをそのまま href に入れると javascript: を差し込まれたときに実行されてしまう。
 * 実データは全て運送会社の https URL なので、http(s) だけを通す。
 */
export function safeUrl(url: unknown): string {
  const s = String(url == null ? '' : url).trim()
  return /^https?:\/\//i.test(s) ? s : ''
}

/** URLクエリの取得。原文と同じく + をスペースに戻す。 */
export function qparam(name: string): string {
  const m = new RegExp('[?&]' + name + '=([^&#]*)').exec(window.location.search || '')
  return m ? decodeURIComponent(m[1]!.replace(/\+/g, ' ')) : ''
}

/** "2026-08-20" → "8/20"。区切りは - と / の両方を受ける。 */
export function fmtMD(s: string | undefined): string {
  const m = String(s || '').match(/(\d{4})[-/](\d{1,2})[-/](\d{1,2})/)
  return m ? `${parseInt(m[2]!, 10)}/${parseInt(m[3]!, 10)}` : ''
}

/**
 * last_updated（UTCのISO）を JST の "M/D HH:MM" にする。
 * 原文どおり +9h してから UTC 系のゲッタで読む。ここを揃えないと9時間ずれる。
 */
export function fmtUpdated(iso: string | undefined): string {
  if (!iso) return ''
  const d = new Date(iso)
  if (isNaN(d.getTime())) return ''
  const j = new Date(d.getTime() + 9 * 3600 * 1000)
  const p = (n: number) => (n < 10 ? '0' : '') + n
  return `${j.getUTCMonth() + 1}/${j.getUTCDate()} ${p(j.getUTCHours())}:${p(j.getUTCMinutes())}`
}

/** 追跡番号のコピー。clipboard API が使えない環境では textarea 経由に落とす。 */
export function copyText(txt: string): void {
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      void navigator.clipboard.writeText(txt)
      return
    }
  } catch {
    /* 落ちても下のフォールバックを試す */
  }
  try {
    const ta = document.createElement('textarea')
    ta.value = txt
    ta.style.position = 'fixed'
    ta.style.opacity = '0'
    document.body.appendChild(ta)
    ta.focus()
    ta.select()
    document.execCommand('copy')
    document.body.removeChild(ta)
  } catch {
    /* コピーできなくても追跡ページは開くので、ここでは何もしない */
  }
}
